import styled from "styled-components";
import Map from "../../assets/map.png";

export const WelcomePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url(${Map});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  min-height: 700px !important;
  width: 100vw;
  overflow-x: hidden;
`;

export const StyledHeader = styled.img`
  position: absolute;
  padding-right: 25px;
`;

export const FlagIcon = styled.img`
  position: absolute;
  margin-bottom: 45px;
  margin-right: 10px;
  padding-right: 25px;
`;

export const RectanglesContainer = styled.div`
  margin-left: 71px;
`;

export const Bookmark = styled.img`
width: 120px;
height: 195px;
`;

export const UpperContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const HeaderContainer = styled.div`
  margin: 0 auto;
  margin-top: -170px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 58px;

  position: relative;
  height: 430px !important;
`;

export const BackgroundBanner = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const BottomContainer = styled.div`
  background-color: var(--bg-dark-blue);
  height: 100px;
  width: 100%;

  display: flex;
  justify-content: center;
`;

export const FooterLogos = styled.img`
  max-width: 480px;
  width: 100%;
  height: 100%;
`;